import React from 'react';
import { Paper, styled, Typography } from '@mui/material';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

import { CopyButton } from '../../../../../components/ui/CopyButton.jsx';

const StyledCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  position: 'relative',
  overflow: 'hidden',

  '& .card-header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  '& .card-title': {
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  '& .card-content': {
    display: 'flex',
    flexDirection: 'column',
  },
  '& .card-field': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px dashed rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(0.5),
  },
  '& .card-label': {
    fontSize: '0.8rem',
    opacity: 0.8,
  },
  '& .card-value': {
    fontWeight: 500,
    textAlign: 'right',
    justifyContent: 'flex-start',
  },
}));

const Header = (props: React.ComponentProps<'div'>) => <div className="card-header" {...props} />;
const Title = (props: React.ComponentProps<'div'>) => <div className="card-title" {...props} />;
const Content = (props: React.ComponentProps<'div'>) => <div className="card-content" {...props} />;
const Field = (props: React.ComponentProps<'div'>) => <div className="card-field" {...props} />;
const Label = (props: React.ComponentProps<typeof Typography>) => <Typography className="card-label" {...props} />;
const Value = ({
  textToCopy,
  ...props
}: Omit<React.ComponentProps<typeof CopyButton>, 'children' | 'textToCopy'> & { textToCopy: string }) => (
  <CopyButton
    className="card-value"
    color="inherit"
    iconOnLeft
    textToCopy={textToCopy}
    disabled={!textToCopy}
    {...props}
  >
    {textToCopy || '-'}
  </CopyButton>
);

interface DetailsCardProps extends React.ComponentProps<typeof StyledCard> {
  title: string;
  icon?: React.ReactNode;
}

export const DetailsCard = ({ title, icon = <HealthAndSafetyIcon />, children, ...props }: DetailsCardProps) => (
  <StyledCard variant="outlined" {...props}>
    <Header>
      <Title>{title}</Title>
      {icon}
    </Header>
    {children}
  </StyledCard>
);

DetailsCard.Header = Header;
DetailsCard.Title = Title;
DetailsCard.Content = Content;
DetailsCard.Field = Field;
DetailsCard.Label = Label;
DetailsCard.Value = Value;
